import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserRoutingModule } from './user-routing.module';
import { UserComponent } from './components/user/user.component';
import { UserManagementComponent } from './components/user-management/user-management.component';
import { UserRoleAddDialogComponent } from './components/user-role-add-dialog/user-role-add-dialog.component';
import { UserAddDailogComponent } from './components/user-add-dailog/user-add-dailog.component';
import { UserRoleAssignDialogComponent } from './components/user-role-assign-dialog/user-role-assign-dialog.component';
import { SharedModule } from '../shared/shared.module';
import { RoleListComponent } from './components/role-list/role-list.component';
import { UserSitesAssignDialogComponent } from './components/user-sites-assign-dialog/user-sites-assign-dialog.component';
import { RoleUserAssignDialogComponent } from './components/role-user-assign-dialog/role-user-assign-dialog.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule } from '@ngneat/transloco';
import { MaterialModule } from '../material/material.module';
import { ReferencesModule } from '../reference/reference.module';
import { UserRegionsComponent } from './components/user-regions/user-regions.component';
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
  declarations: [
    RoleListComponent,
    UserComponent,
    RoleUserAssignDialogComponent,
    UserAddDailogComponent,
    UserManagementComponent,
    UserRoleAddDialogComponent,
    UserRoleAssignDialogComponent,
    UserSitesAssignDialogComponent,
    UserRegionsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    UserRoutingModule,
    NgxIntlTelInputModule,
    MatFormFieldModule,
    RouterModule,
    MaterialModule, 
    ReactiveFormsModule, 
    TranslocoModule,
    //ReferencesModule,
    FormsModule,
    FlexLayoutModule,
  ],
})
export class UserModule { }
